export const diseases_allergy_eng = [    
    {
        label: 'Allergic rhinitis',
        label_show: 'Allergic Rhinitis',
        page: 13,
        Xpos_image: '180px',
        Ypos_image: '480px',
        Xlabel: '175px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'allergicrhiniitis_0' },
          { min: 4, max: 6, image: 'allergicrhiniitis_1' },
          { min: 7, max: 10, image: 'allergicrhiniitis_2' }
        ]
    },
    {
      label: 'Asthma',
      label_show: 'Asthma',
      page: 13,
      Xpos_image: '300px',
      Ypos_image: '480px',
      Xlabel: '316px',
      Ylabel: '565px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'asthma_0' },
        { min: 4, max: 6, image: 'asthma_1' },
        { min: 7, max: 10, image: 'asthma_2' }
      ]
    },
    {
        label: 'Eczema',
        label_show: 'Eczema',
        page: 13,
        Xpos_image: '420px',
        Ypos_image: '480px',
        Xlabel: '435px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
            { min: 1, max: 3, image: 'eczema_0' },
            { min: 4, max: 6, image: 'eczema_1' },
            { min: 7, max: 10, image: 'eczema_2' }
        ]
    },

    
    {
        label: 'Food allergy',
        label_show: 'Food Allergy',
        page: 13,
        Xpos_image: '540px',
        Ypos_image: '480px',
        Xlabel: '545px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'foodallergy_0' },
          { min: 4, max: 6, image: 'foodallergy_1' },
          { min: 7, max: 10, image: 'foodallergy_2' }
        ]
    },    
]

export const diseases_allergy_thai = [
    {
        label: 'Eczema',
        label_show: 'ภูมิแพ้ผิวหนังอักเสบ',
        page: 12,
        Xpos_image: '420px',
        Ypos_image: '480px',
        Xlabel: '410px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
            { min: 1, max: 3, image: 'eczema_0' },
            { min: 4, max: 6, image: 'eczema_1' },
            { min: 7, max: 10, image: 'eczema_2' }
        ]
    },
    {
        label: 'Allergic rhinitis',
        label_show: ' ภูมิแพ้อากาศ',
        page: 12,
        Xpos_image: '180px',
        Ypos_image: '480px',
        Xlabel: '184px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'allergicrhiniitis_0' },
          { min: 4, max: 6, image: 'allergicrhiniitis_1' },
          { min: 7, max: 10, image: 'allergicrhiniitis_2' }
        ]
    },
    {
      label: 'Asthma',
      label_show: 'หอบหืด',
      page: 12,
      Xpos_image: '300px',
      Ypos_image: '480px',
      Xlabel: '320px',
      Ylabel: '565px',
      width: '79px',
      height: 'auto',
      result_comp: [
        { min: 1, max: 3, image: 'asthma_0' },
        { min: 4, max: 6, image: 'asthma_1' },
        { min: 7, max: 10, image: 'asthma_2' }
      ]
    },
    {
        label: 'Food allergy',
        label_show: 'ภูมิแพ้อาหาร',
        page: 12,
        Xpos_image: '540px',
        Ypos_image: '480px',
        Xlabel: '548px',
        Ylabel: '565px',
        width: '79px',
        height: 'auto',
        result_comp: [
          { min: 1, max: 3, image: 'foodallergy_0' },
          { min: 4, max: 6, image: 'foodallergy_1' },
          { min: 7, max: 10, image: 'foodallergy_2' }
        ]
    },    
]

export const diseases_image_allergy_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_allergy_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];